<template>
  <div class="container">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="@/assets/logo_blue_new.png" />
          <span class="log-desc"
            >淘宝店铺管理专家 <span class="version">版本：V3.00</span>
          </span>
        </div>
        <div class="topBtn">
          <el-button type="primary" @click="go2Fuwu">
            <i class="fa fa-shopping-cart fa-lg"></i>&nbsp;&nbsp;现在订购
          </el-button>
          <el-button type="primary" @click="go2TbLogin">
            <i class="fa fa-home fa-lg"></i>&nbsp;&nbsp;立即登录
          </el-button>
        </div>
      </el-header>
      <el-main>
        <div>
          <div class="bg-carousel">
            <el-carousel height="440px" :interval="5000" arrow="hover">
              <el-carousel-item v-for="item in carouselData" :key="item.id">
                <el-image
                  style="height: 100%;width:100%;"
                  :src="item.url"
                  :fit="item.fit"
                ></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>

          <div>
            <el-row type="flex" class="func-panel" justify="center">
              <el-col :span="8"
                ><img src="@/assets/func1.png" class="func-pic"
              /></el-col>
              <el-col :span="8">
                <div class="func-desc">
                  <span class="func-title"> 重复铺货检测</span>
                  <div class="func-desc-list">
                    <span style="color:#C0C4CC"
                      >彻底解决重复铺货处罚，保障店铺合规运营</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      ><b>一键多维度检测</b>：标题 | 主图 | 副图 | 属性 | 货号 |
                      商家编码 | 在售中宝贝 | 已下架宝贝</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      ><b>实时防御</b
                      >：系统7x24小时不间断自动检测，短信邮件提醒</span
                    >
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" class="func-panel" justify="center">
              <el-col :span="8">
                <div class="func-desc">
                  <span class="func-title"> 评价管理</span>
                  <div class="func-desc-list">
                    <span style="color:#C0C4CC"
                      >省心省力，为店铺信用安全护航</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      ><strong>自动评价</strong
                      >：五种模式随意设定，评价模板自由选择</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      ><strong>中差评提醒</strong
                      >：中差评第一时间短信和邮件提醒，7x24不间断监控</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      ><strong>黑名单买家</strong
                      >：不自动评价，订单第一时间提醒，中差评自动加入黑名单</span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="8"
                ><img src="@/assets/func2.png" class="func-pic right"
              /></el-col>
            </el-row>
            <el-row type="flex" class="func-panel" justify="center">
              <el-col :span="8"
                ><img src="@/assets/func3.png" class="func-pic"
              /></el-col>
              <el-col :span="8">
                <div class="func-desc">
                  <span class="func-title"> 自动上架</span>
                  <div class="func-desc-list">
                    <span style="color:#C0C4CC"
                      >利用淘宝规则，引爆店铺流量</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      ><strong>4中上架模式设定</strong>：高峰期 | 避开高峰期 |
                      时间均分 | 手工设置</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span>一键开启简单快捷，报表直观每日 | 每周上架情况</span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" class="func-panel" justify="center">
              <el-col :span="8">
                <div class="func-desc left">
                  <span class="func-title">
                    <!-- <i class="fa fa-window-minimize fa-rotate-90"></i> -->
                    库存预警</span
                  >
                  <div class="func-desc-list">
                    <span style="color:#C0C4CC"
                      >智能提醒提前补货，预防断货</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      >任意库存参数随意设置，SKU级别库存检测，免费邮件、短信提醒</span
                    >
                  </div>
                </div>
              </el-col>
              <el-col :span="8"
                ><img src="@/assets/func4.png" class="func-pic right"
              /></el-col>
            </el-row>

            <el-row type="flex" class="func-panel" justify="center">
              <el-col :span="8"
                ><img src="@/assets/func5.png" class="func-pic left"
              /></el-col>
              <el-col :span="8">
                <div class="func-desc">
                  <span class="func-title">
                    <!-- <i class="fa fa-window-minimize fa-rotate-90"></i> -->
                    7天内无条件退款</span
                  >
                  <div class="func-desc-list">
                    <span style="color:#C0C4CC"
                      >权益保障，随时退款，不好用不要钱</span
                    >
                  </div>
                  <div class="func-desc-list">
                    <span
                      >郑重承诺：如果您对我们的应用不满意，在订购后7天内无条件全额退款！</span
                    >
                  </div>
                </div>
              </el-col>
            </el-row>

            <el-row type="flex" class="login-btn" justify="center">
              <el-col :span="24">
                <div>
                  <el-button
                    type="primary"
                    style="height:50px; width: 170px;font-size:16px"
                    @click="go2Fuwu"
                  >
                    <i class="fa fa-shopping-cart fa-lg"></i
                    >&nbsp;&nbsp;现在订购
                  </el-button>
                  <el-button
                    type="primary"
                    style="height:50px; width: 170px;font-size:16px"
                    @click="go2TbLogin"
                  >
                    <i class="fa fa-home fa-lg"></i>&nbsp;&nbsp;立即登录
                  </el-button>
                  <el-button
                    v-if="!this.global.PROD_ENV"
                    type="primary"
                    style="height:50px; width: 170px;font-size:16px"
                    @click="testLogin"
                  >
                    <i class="fa fa-shopping-cart fa-lg"></i
                    >&nbsp;&nbsp;测试登录
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <div class="copyright">
          <div>
            联系我们: edianzhang@163.com | 电话：0755-82562190 |
            <span
              ><a
                target="_blank"
                href="http://amos.alicdn.com/msg.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
                ><img
                  border="0"
                  src="http://amos.alicdn.com/online.aw?v=2&amp;uid=e%E5%BA%97%E9%95%BF%E8%BD%AF%E4%BB%B6&amp;site=cntaobao&amp;s=1&amp;charset=utf-8"
                  alt="点击这里给我发消息"
              /></a>
            </span>
          </div>

          <div>
            Copyright©2011-2021 深圳市雨帆信息技术有限公司 e店长 All Right
            Reserved
          </div>
          <div>
            ICP证：
            <a href="https://beian.miit.gov.cn/" target="_blank" style="">
              粤ICP备14011677号</a
            >
            |
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030402005087"
              style=""
            >
              <img src="@/assets/beian.png" style="float:left;" />
              粤公网安备 44030402005087号
            </a>
          </div>
        </div>
      </el-main>

      <!-- <el-footer>
        <uf-footer></uf-footer>
      </el-footer> -->
    </el-container>
  </div>
</template>

<script>
import UfFooter from "@/views/Layout/UfFooter";
export default {
  components: { UfFooter },
  name: "Login",
  data() {
    return {
      carouselData: [
        {
          url: require("@/assets/home_bg30.jpg"),
          title: "",
          fit: "fill",
          id: 1
        },
        {
          url: require("@/assets/home_bg40.jpg"),
          title: "",
          fit: "fill",
          id: 2
        },
        {
          url: require("@/assets/home_bg20.jpg"),
          title: "",
          fit: "fill",
          id: 3
        }
      ]
    };
  },
  methods: {
    go2Fuwu() {
      window.location.href = this.global.TAOBAO_FUWU_APP_URL;
    },
    go2TbLogin() {
      window.location.href = this.global.TAOBAO_OAUTH_URL;
    },
    testLogin() {
      //console.log(this.global.PROD_ENV);
      window.location.href = this.global.baseUrl + "/login/test";
    },
    go2New() {
      this.$alert(
        '尊敬的用户，我们启用了新的域名<b><a href="http://www.edianzhang.com" target="_self">www.edianzhang.com</a></b>，后续操作将跳转到新的域名，请收藏下新的域名，感谢您的支持！',
        "新域名启动通知",
        {
          confirmButtonText: "确定",
          dangerouslyUseHTMLString: true,
          showClose: false,
          callback: action => {
            window.location.href = "http://www.edianzhang.com";
          }
        }
      );
    }
  },
  mounted() {
    this.go2New();
  }
};
</script>

<style lang="scss" scoped>
.el-container {
  position: absolute;
  width: 100%;
  padding-top: 0px;
  margin-top: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  min-width: 1200px;
}
.el-header {
  /**background-color: #f34541;**/
  color: #606266;
  z-index: 1000;
  .logo {
    position: absolute;
    padding-top: 10px;
    img {
      float: left;
      padding-left: 0px;
      height: 40px;
    }
    .log-desc {
      padding-top: 0px;
      text-align: center;
      float: left;
      margin: 10px 10px 10px 10px;
      .version {
        font-size: 14px;
        padding-left: 20px;
        color: #909399;
      }
    }
  }
  .topBtn {
    padding-top: 0px;
    padding-right: 0px;
    float: right;
    margin: 10px 0px 10px 10px;
    text-align: center;
  }
}
.el-main {
  margin-top: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
  .bg-carousel {
    height: 440px;
    background: #00acec;
  }
  .func-panel {
    vertical-align: middle;
    padding-top: 50px;
    height: 350px;
    .func-pic {
      height: 300px;
    }
    .func-desc {
      padding-top: 60px;
      .func-title {
        color: #303133;
        font-size: 32px;
        padding-bottom: 100px;
        margin-bottom: 100px;
      }
      .func-desc-list {
        color: #909399;
        line-height: 30px;
        padding-top: 10px;
      }
    }
    .right {
      float: right;
      padding-right: 20px;
    }
    .left {
      float: left;
      padding-left: 20px;
    }
    .center {
      text-align: center;
    }
  }

  .login-btn {
    padding-top: 0px;
    height: 200px;
    text-align: center;
    width: 100%;
    display: inline-block;
  }

  .copyright {
    text-align: center;
    height: 100px;
    padding-top: 10px;
    background-color: #282c33;
    font-size: 14px;
    line-height: 30px;
    color: #939393;
    a {
      display: inline-block;
      text-decoration: none;
      height: 20px;
      line-height: 20px;
    }
    a:link {
      color: #939393;
    }
    a:hover {
      color: #939393;
    }
    a:visited {
      color: #939393;
    }
  }
}
.el-footer {
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  text-align: center;
  line-height: 1.5em;
  .copyright {
    top: 0px;
    margin-top: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login1.vue